// extracted by mini-css-extract-plugin
export default {"form":"styles_form__-SmBm","form-body":"styles_form-body__BQk3m","form-footer":"styles_form-footer__ED0CD","fullView":"styles_fullView__ho2R9","shimmer":"styles_shimmer__sK5+f"};